export enum DefaultRange {
  Last7 = "last7",
  Last30 = "last30",
  Last3Months = "last3Months",
  CurrentMonth = "currentMonth",
  RiskManagement = "risk-management",
  Emissions = "emissions",
  PortCongestion = "port-congestion",
  None = "none"
}

export default DefaultRange;
